import React from 'react';
import { BaSeInput } from '@base/react';
import { SquareSearchInputContainer } from '../StyledComponents';

export const SquareSearchInput = ({
  value = '',
  iconColor = '#0061C6',
  label = 'Código PRATIF',
  disabled = false,
  onChange = () => {},
  onClick = () => {},
}) => {
  return (
    <SquareSearchInputContainer>
      <BaSeInput
        label={label}
        iconButton={{
          name: 'search',
          type: 'primary-default',
          typeButton: 'base-icon',
          value: 'Default',
          color: iconColor,
          action: onClick,
        }}
        value={value}
        onChange={onChange}
        placeholder="MT005006ATAS"
        size="big"
        typeInput="text"
        width="100%"
        isDisabled={disabled}
      />
    </SquareSearchInputContainer>
  );
};
